import RichText from "@/components/RichText";
import MutedVideo from "../components/MutedVideo";
import { BODY, CONTAINER, DARK_BG, SECTION } from "../tokens";

// Deux colonnes : le discours métier (paragraphe, amorce, H2 « Chaque
// détail compte. », deux paragraphes) / la vidéo de l'atelier (min 400px)
// avec son étiquette en bas à gauche sur voile sombre.
export default function TextVideoSection({ props = {} }) {
  return (
    <section>
      <div className={`${CONTAINER} ${SECTION} grid gap-10 md:gap-12 [grid-template-columns:repeat(auto-fit,minmax(300px,1fr))] items-start`}>
      <div>
        <RichText as="div" preserveParagraphs className={`${BODY} [&_p]:mb-6 [&_p:last-child]:mb-0`} html={props.body_intro} />
        <RichText as="div" className="block text-[13px] tracking-[0.05em] font-light text-ash mt-6 mb-2.5" html={props.lead_in} />
        <RichText
          as="h2"
          className="block font-display font-normal text-[clamp(26px,3vw,36px)] leading-[1.2] text-ink mb-[26px]"
          html={props.heading}
        />
        <RichText as="div" preserveParagraphs className={`${BODY} [&_p]:mb-5 [&_p:last-child]:mb-0`} html={props.body} />
      </div>
      <div className="relative min-h-[400px]" style={DARK_BG}>
        <MutedVideo
          src={props.video_url}
          poster={props.poster_image}
          className="w-full h-full min-h-[400px] object-cover block"
        />
        {props.video_caption && (
          <div className="absolute left-0 bottom-0 py-3.5 px-[18px] bg-[rgba(10,8,6,0.72)] text-[10px] tracking-[0.22em] uppercase text-cream/[0.85]">
            {props.video_caption}
          </div>
        )}
      </div>
      </div>
    </section>
  );
}
